import { get, post } from '../request';
import { defaultPageSize } from '../../constants';

export async function fetchSearchOptions(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisaldemo/config/propertysearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchProperty(
  { appraisalService },
  authenticationToken,
  {
    year = '2017',
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    filterModel,
    searchOptions,
  },
) {
  let url = `${appraisalService}/appraisaldemo/property/search/${year}/current`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }
  const { body } = await post(authenticationToken, url, searchOptions);
  return body;
}

export async function fetchFields({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisaldemo/config/propertysearchresults `;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSubdivisionCodes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisaldemo/config/codes/subdivision `;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCodes({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisaldemo/config/codes`;
  const { body } = await get(authenticationToken, url);
  return body;
}
